import {Button, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import React from 'react';
import {DialogProps} from "./DialogProps";
import {IApplicationChecklistItemHistory} from "../../Interfaces/Application/IApplicationChecklistItemHistory";
import {IEmployee} from "../../Interfaces/Admin/IEmployee";
import {IChecklistItemStatus} from "../../Interfaces/Common/IChecklistItemStatus";
import {ApplicationChecklistItemComponent} from "../Views/ApplicationChecklistViewer";

export interface ApplicationChecklistItemHistoryDialogProps extends DialogProps<null> {
  checklistItemDescription: string | undefined;
  applicationChecklistItemHistories: IApplicationChecklistItemHistory[];
  employees: IEmployee[];
  checklistItemStatuses: IChecklistItemStatus[];
}

export default function ApplicationChecklistItemHistoryDialog(props: ApplicationChecklistItemHistoryDialogProps) {

  return (
    <>
      <DialogTitle style={{ cursor: 'move', width: '500px' }} id='draggable-dialog-title'>
        History for Checklist Item-
        <Typography>{props.checklistItemDescription ?? ''}</Typography>
      </DialogTitle>
      <DialogContent>
        {
          props.applicationChecklistItemHistories.length === 0 && <DialogContent><p>There is no history to show.</p></DialogContent>
        }
        {
          props.applicationChecklistItemHistories.map((cih, key: number) => {            
            return (
              <ApplicationChecklistItemComponent
                key={key}
                applicationChecklistItem={{ //morphs it into an IApplicationChecklistItem object
                  id: cih.id,
                  applicationChecklistId: '',
                  checklistItemStatusId: cih.checklistItemStatusId,
                  comment: cih.comment,
                  checklistItemId: '',
                  modifiedBy: cih.createdBy,
                  modifiedDate: cih.createdDate
                }}
                employees={props.employees}
                checklistItemStatuses={props.checklistItemStatuses}
                disabled={true}
                showHistoryButton={false}
                clear={{}}
              />
            );
          })
        }
      </DialogContent >
      <DialogActions>
        <Button autoFocus onClick={props.closeDialog} color='primary'>
          Close
        </Button>
      </DialogActions>
    </>
  );
}
